import Element from './Element';
import OverlayComponent from '../../Component/UI/Overlay';
import Interactable from '../../Component/Interactable';
import AnimationComponent from '../../Component/Animation';
import PIXIRenderer from '../../System/Render/PIXIRenderer';
import ElementComponent from '../../Component/UI/Element';

export default class Overlay extends Element {
    create(params: any): void {
        super.create({
            type: 'group',
            name: 'overlay',
            layout: {
                anchors: params.anchors || [0, 0, 1, 1],
                pivot: [0.5, 0.5],
                ...params,
            },
            components: [
                {
                    type: 'transparency',
                    data: { alpha: params.alpha ? params.alpha : 0 },
                },
                {
                    type: 'rect',
                    data: {
                        color:
                            params.color !== undefined
                                ? params.color
                                : [0, 0, 0, 204],
                    },
                },
            ],
            ...params,
        });
    }

    protected onCreate(params: any): void {
        super.onCreate(params);

        this.addComponent(OverlayComponent, params);

        this.addComponent(AnimationComponent, params);

        this.addComponent(Interactable, {
            enabled: false,
            buttonMode: false,
            ...params,
        });
        PIXIRenderer.rootContainer.on('resized', this.onResize.bind(this));
    }
    protected onResize(screen: {
        CANVAS_WIDTH: number;
        CANVAS_HEIGHT: number;
    }) {
        try {
            this.container.resize(
                PIXIRenderer.renderer.width,
                PIXIRenderer.renderer.height
            );
        } catch (e) {
            console.error(e);
        }
    }
    public destroy() {
        PIXIRenderer.rootContainer.off('resized');
        super.destroy();
    }
}
